import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiClient } from '@/lib/apiClient';
import { ArrowRight, Save, UserPlus } from 'lucide-react';

export default function CompanyAddEmployee() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        full_name: '', personnel_code: '', national_code: '', mobile_phone: '', department: ''
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            // تبدیل فیلدهای خالی به null تا Pydantic خطای 422 ندهد
            const cleanData = {
                ...formData,
                personnel_code: formData.personnel_code.trim() || null,
                national_code: formData.national_code.trim() || null,
                department: formData.department.trim() || null,
            };

            const { error } = await apiClient.POST('/api/v1/company/employees/bulk', {
                body: { employees: [cleanData] }
            });
            if (error) throw new Error(error.detail);

            alert('کارمند با موفقیت اضافه شد');
            navigate('/company/employees'); // بازگشت به لیست پس از ثبت
        } catch (error) {
            alert('خطا در ثبت کارمند: ' + error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="company-add-employee" style={{ direction: 'rtl', maxWidth: '800px', margin: '0 auto' }}>

            {/* هدر صفحه */}
            <div className="company-add-employee-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem', background: '#fff', padding: '1rem 1.5rem', borderRadius: '12px', border: '1px solid #e5e7eb' }}>
                <h2 style={{ margin: 0, fontSize: '1.2rem', color: '#1e293b', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <UserPlus size={22} color="#2563eb" />
                    افزودن کارمند جدید
                </h2>

                <button
                    onClick={() => navigate('/company/employees')}
                    style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', background: '#f1f5f9', color: '#475569', border: '1px solid #cbd5e1', padding: '0.5rem 1rem', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold', fontSize: '0.85rem' }}
                >
                    <ArrowRight size={16} /> بازگشت به لیست
                </button>
            </div>

            {/* فرم ثبت */}
            <div className="company-add-employee-form" style={{ background: '#fff', padding: '2rem', borderRadius: '12px', border: '1px solid #e5e7eb', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
                <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1.2rem' }}>

                    <div>
                        <label style={{ display: 'block', marginBottom: '0.4rem', fontSize: '0.9rem', fontWeight: 'bold', color: '#334155' }}>نام و نام خانوادگی *</label>
                        <input type="text" placeholder="مثلا: علی رضایی" value={formData.full_name} onChange={e => setFormData({...formData, full_name: e.target.value})} required style={{ width: '100%', padding: '0.7rem', borderRadius: '8px', border: '1px solid #cbd5e1', fontSize: '0.95rem' }} />
                    </div>

                    <div className="company-employee-code-fields" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                        <div>
                            <label style={{ display: 'block', marginBottom: '0.4rem', fontSize: '0.9rem', fontWeight: 'bold', color: '#334155' }}>کد پرسنلی (اختیاری)</label>
                            <input type="text" placeholder="مثلا: 1001" value={formData.personnel_code} onChange={e => setFormData({...formData, personnel_code: e.target.value})} style={{ width: '100%', padding: '0.7rem', borderRadius: '8px', border: '1px solid #cbd5e1', fontSize: '0.95rem' }} />
                        </div>
                        <div>
                            <label style={{ display: 'block', marginBottom: '0.4rem', fontSize: '0.9rem', fontWeight: 'bold', color: '#334155' }}>کد ملی (اختیاری)</label>
                            <input type="text" placeholder="کد ملی ۱۰ رقمی" value={formData.national_code} onChange={e => setFormData({...formData, national_code: e.target.value})} style={{ width: '100%', padding: '0.7rem', borderRadius: '8px', border: '1px solid #cbd5e1', fontSize: '0.95rem' }} />
                        </div>
                    </div>

                    <div>
                        <label style={{ display: 'block', marginBottom: '0.4rem', fontSize: '0.9rem', fontWeight: 'bold', color: '#334155' }}>شماره موبایل *</label>
                        <input type="text" placeholder="09123456789" value={formData.mobile_phone} onChange={e => setFormData({...formData, mobile_phone: e.target.value})} required style={{ width: '100%', padding: '0.7rem', borderRadius: '8px', border: '1px solid #cbd5e1', fontSize: '0.95rem', direction: 'ltr', textAlign: 'right' }} />
                    </div>

                    <div>
                        <label style={{ display: 'block', marginBottom: '0.4rem', fontSize: '0.9rem', fontWeight: 'bold', color: '#334155' }}>دپارتمان (اختیاری)</label>
                        <input type="text" placeholder="مثلا: فروش، فنی..." value={formData.department} onChange={e => setFormData({...formData, department: e.target.value})} style={{ width: '100%', padding: '0.7rem', borderRadius: '8px', border: '1px solid #cbd5e1', fontSize: '0.95rem' }} />
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '1rem' }}>
                        <button type="submit" disabled={loading} className="btn-primary" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.7rem 2rem', borderRadius: '8px', fontWeight: 'bold', fontSize: '1rem', cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1 }}>
                            <Save size={18} /> {loading ? 'در حال ثبت...' : 'ثبت کارمند'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}